import I18n from 'lib/i18n'

import React, { Component } from 'react'
import PropTypes from 'prop-types'

import Tooltip from 'rc-tooltip'
import nearMe from './assets/near_me.svg'

export default class GeolocateButton extends Component {
  static propTypes = {
    onClick: PropTypes.func.isRequired,
    isGeolocating: PropTypes.bool,
    withMap: PropTypes.bool,
    fullScreenFiltersPage: PropTypes.bool,
    locationFilterComponent: PropTypes.bool
  }

  render () {
    const { onClick, isGeolocating, withMap, fullScreenFiltersPage, locationFilterComponent } = this.props
    return fullScreenFiltersPage && locationFilterComponent ? (
      <div className='near-me-container'>
        <img src={nearMe} width='30' height='19' alt='Near me' />
        <a href='#' onClick={onClick}>
          {I18n.t('search.filters.near_me')}
        </a>
      </div>
    ) : (
      <Tooltip placement='left' trigger={['hover']} overlay={<span>{I18n.t('react.search.geolocation.tooltip')}</span>}>
        <span
          className={`map-button map-geolocate-button ${withMap ? '' : 'without-map'} ${
            isGeolocating ? ' geolocating' : ''
          }`}
          onClick={onClick}
        />
      </Tooltip>
    )
  }
}
